import { HD, FULL_HD } from '@bedrock-rdk/constants';
import { makeDefaultStylingContext } from '../../../utils/style';

export const defaultContext = makeDefaultStylingContext();

export const ITEMS_PER_ROW = {
  [HD]: 3,
  [FULL_HD]: 4,
};
